import { Button } from '@acpaas-ui/react-components';
import _ from 'lodash';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReset } from '../actions/fetch.actions';
import { selectedChange } from '../actions/table.actions';
import { MODALS } from '../constants/modals.constants';
import StaticTable from '../containers/core/StaticTable';
import { useForm } from '../hooks/useForm.hook';
import { useModal } from '../hooks/useModal.hook';
import { DOSSIER_ASSIGNED_RESOURCE } from '../resources/dossier.assigned.resource';
import { tableSelectedSelector } from '../selectors/resources.selectors';
import dossiersService from '../services/api/dossiers.service';
import AssignedToDossierSearchContactsModal from './AssignToDossierSearchContactsModal';
import Modal from './Modal';
import ModalTitle from './ModalTitle';

const AssignToDossierModal = ({ isOpen, assigned, dossierId, onUpdated, onClose }) => {
  const dispatch = useDispatch();
  const modalContentRef = useRef(null);
  const contactsSearchModal = useModal(MODALS.ASSIGN_TO_DOSSIER_CONTACTS_SEARCH_MODAL);
  const { isSubmitting, data, reset, input, submitStart, submitOk, submitError, error } = useForm(assigned);
  const selected = useSelector((state) => tableSelectedSelector(state, { resource: DOSSIER_ASSIGNED_RESOURCE }));

  const handleClose = () => {
    onClose();
    reset();
  };

  const updateAssigned = (assigned) => {
    submitStart();
    dossiersService.assignedUsersChange(dossierId, assigned, {
      onSuccess: () => {
        submitOk();
        input(assigned, 'users');
        onUpdated(assigned, 'users', 'assigned');
        dispatch(fetchReset(DOSSIER_ASSIGNED_RESOURCE));
        dispatch(selectedChange(DOSSIER_ASSIGNED_RESOURCE, []));
      },
      onError: (message) => {
        submitError({ users: message });
      }
    });
  };

  const handleContactsAssigned = (contacts = []) => {
    updateAssigned(_.uniqBy([...(data?.users ?? []), ...contacts], 'id'));
  };

  const handleUnassign = () => {
    updateAssigned(data?.users?.filter((u) => !selected.includes(u.id)));
  };

  return (
    <Modal
      ref={modalContentRef}
      title={<ModalTitle title="Toegekend aan" />}
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      onClose={handleClose}
      disableConfirm
      disableCancel
      width={1000}
    >
      <StaticTable
        resource={DOSSIER_ASSIGNED_RESOURCE}
        data={data?.users ?? []}
        forceLoading={isSubmitting}
        actions={[
          selected?.length > 0 && (
            <Button
              key="remove-assigned-from-dossier"
              iconLeft="ai-remove"
              size="small"
              type="danger"
              className="u-margin-right-xs"
              onClick={handleUnassign}
              disabled={isSubmitting}
            >
              Toewijzen opheffen
            </Button>
          ),
          <Button
            key="add-assigned-to-dossier"
            iconLeft="ai-add"
            size="small"
            className="u-margin-right-xs"
            onClick={contactsSearchModal.onOpen}
            disabled={isSubmitting}
          >
            Toewijzen
          </Button>
        ].filter((x) => !!x)}
      />
      {error && <small className="u-block u-margin-top-sm u-text-danger">{error}</small>}
      <AssignedToDossierSearchContactsModal {...contactsSearchModal} onConfirm={handleContactsAssigned} />
    </Modal>
  );
};

export default AssignToDossierModal;
